<template>
    <div id="search_history_wrapper">
        <div id="search_history">
            <div id="search_history_lbl"
                :class="[{'color-mass': theme == 'mass'}, {'color-prestige': theme == 'prestige'}]">
                {{lbl.reward.search_history}}
            </div>
            <img class="clear-history-btn" 
                src="@/assets/icon/mass/ic_mass_clear_history.svg"
                v-if="theme == 'mass'"
                @click="onClearHistory()" />
            <img class="clear-history-btn"
                src="@/assets/icon/prestige/ic_prestige_clear_history.svg" 
                v-if="theme == 'prestige'"
                @click="onClearHistory()" />
        </div>
        <div id="search_history_list">
            <div class="search-history-item"
                :class="[{'color-mass': theme == 'mass'}, {'color-prestige': theme == 'prestige'}]"
                v-for="(history, i) in wordSearch"
                :key="i"
                @click="onSelectKeyWord(history)">
                {{ history }}
            </div>
        </div>
    </div>
</template>
<script>
// helper
import Account from '@/helper/AccountHelper.js';
// service
import BzbsSearchHistory from '@/core/History/service/BzbsSearchHistory.js';
export default {
    name: 'SearchHistory',
    props: {
        // v-model
        value: { type: String },
        // props
        modalController: { type: Object },
        // text
        lbl: { type: Object }
    },
    computed: {
        isAmbassador: function () {
            return this.$store.state.isAmbassador;
        },
        theme: function () {
            return this.$store.state.theme;
        }
    },
    data: function () {
        return {
            list: [],
            wordSearch: ''
        };
    },
    created: function () {
        this.getList();
    },
    methods: {
        // event
        onClearHistory: function () {
            this.showLoading();

            const token = Account.getToken();
            BzbsSearchHistory.apiClearCampaignSearchHistory(token)
                .then(() => {
                    this.hideLoading();
                    this.list = [];
                    
                    this.isLoaded = true;
                }).catch(err => {
                    this.hideLoading();
                    this.list = [];
                    this.isLoaded = true;
                    this.errorApi(err, this.errorHandler);
                });
        },
        onSelectKeyWord: function (keyword) {
            this.$emit('input', keyword);
            this.$emit('onSelectKeyWord');
        },  
        // method
        getList: function () {
            this.list = [];
            this.showLoading();

            const token = Account.getToken();
            BzbsSearchHistory.apiGetCampaignSearchHistory(token)
                .then(res => {
                    this.hideLoading();
                    this.list = [];
                    for (let history of res) {
                        this.list.push(history.keyword);
                        this.removeDuplicates(this.list);
                    }

                    this.isLoaded = true;
                }).catch(err => {
                    this.hideLoading();
                    this.list = [];
                    this.isLoaded = true;
                    this.errorApi(err, this.errorHandler);
                });
        },
        removeDuplicates: function(data) {
            this.wordSearch = data.filter((value, index) => data.indexOf(value) === index)
        },
        // loading
        showLoading: function () {
            if (this.isLoading) return true;

            this.isLoading = true;
            this.modalController.loadingModal.show();

            return false;
        },
        hideLoading: function () {
            this.isLoading = false;
            this.modalController.loadingModal.hide();
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
#search_history_wrapper {
    padding: {
        top: 30px;
        left: 18px;
        right: 18px;
        bottom: 30px;
    };
}

#search_history {
    @extend %display-flex;
    justify-content: space-between;
    margin-bottom: 5px;

    #search_history_lbl {
        // font-family: $heading;
        font-size: 1.25rem;
        margin: {
            top: auto;
            bottom: auto;
        }

        &.color-mass{
            color: $mass_theme_color;
        }
        &.color-prestige{
            color: $prestige_theme_color;
        }
    }

    .clear-history-btn {
        margin: {
            top: auto;
            bottom: auto;
        }
    }
}

#search_history_list {
    .search-history-item {
        padding: 8px 15px;
        // font-family: $heading;

        &.color-mass{
            color: $mass_detail_font_color;
            border-bottom: 1px solid #d6d8da;
        }
        &.color-prestige{
            color: $prestige_theme_color;
            border-bottom: 1px solid #707070;
        }
    }
}
</style>